import commonUtils from "@/utils/common.utils";
import store from "../store/store";
import auth from "@/utils/auth.utils";
import Swal from "sweetalert2";

const authGuard = async (to, from, next) => {
  try {
    console.log("to", to.params);
    console.log("from", from.params);
    // 沒有 token 保持未登錄狀態停留在該頁面
    if (!store.getters['userData/accessToken']) {
      next()
      return
    }
    // 如果token 過期則顯示錯誤訊息並登出停留在該頁面
    if (!store.getters['userData/isLogin']) {
      if (!Swal.isVisible()) commonUtils.createToast("error", "登入狀態已經過期,請重新登入");
      auth.logout();
      next()
      return
    }

    // 只需攔截後台是否有購買線上點餐功能
    if (!store.getters['basic/enableOnlineOrder']) throw ('線上點餐暫停接單中')
    next();
  } catch (error) {
    commonUtils.createToast('error', error)
    console.error("table order guard error", error);
    next({ path: `/${to.params.store}` });
  }
};

export default authGuard;
